import React from 'react';
import { connect } from 'react-redux';
import Link from 'next/link';
import css from './Breadcrumb.less';

const Breadcrumb = props => {
  const { city, tuan } = props;
  const { currentCity } = city;
  const { product } = tuan;
  return (
    <div className={css.content}>
      <p className={css.item}>{currentCity.name}</p>
      <p className={css.item}>服务分类</p>
      {product.navigation_category && product.navigation_category.id ? (
        <Link
          href={{
            pathname: '/category/[id]/[type]/',
          }}
          as={{
            pathname: `/category/${product.navigation_category.id}/1/`,
          }}
        >
          <a className={css.item}>{product.navigation_category.name}</a>
        </Link>
      ) : null}
      {product.navigation_category &&
      product.navigation_category.show_level_category.id ? (
        <Link
          href={{
            pathname: '/category/[id]/[type]/',
          }}
          as={{
            pathname: `/category/${product.navigation_category.show_level_category.id}/2/`,
          }}
        >
          <a className={css.item}>
            {product.navigation_category.show_level_category.name}
          </a>
        </Link>
      ) : null}
    </div>
  );
};

export default connect(({ city, tuan }) => ({
  city,
  tuan,
}))(Breadcrumb);
